/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import Select from 'react-select';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import MultiAxisBar from './MultiAxisBar';
import { aovHeaderData, vendorNameMapping } from '../helper';
import ViewSalesReportModal from '../SalesCategoryByDay/ViewSalesReportModal';

const keyRef = {
    aov: "Average Order Value",
    aupt: "Average Units Per Transaction"
}

const options = [{ value: 0, label: 'daily' }, { value: 1, label: 'Monthly' }]

const AOVByPurchaseDate = ({ dir, dataToShowForDatesSelected, title, height, isSalesKey, vendor }) => {
    const [dailyMonthlyOptions, setSelectedOptions] = useState(options[0])
    const [isOpen, setIsOpen] = useState(false);

    let salesBreakdownByDay = {};

    const viewReportButton = () => (
        <div className="view-report">
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
            >
                View Report
            </button>
        </div>
    )

    const reduceCallbackDaily = (acc, day) => {

        if (acc[day?.purchaseDate]) {
            acc?.[day?.purchaseDate]?.push(day)
        } else {
            acc[day?.purchaseDate] = [day]
        }

        return acc
    }
    const reduceCallbackMonthly = (acc, day) => {

        if (acc[day?.salesMonth]) {
            acc?.[day?.salesMonth]?.push(day)
        } else {
            acc[day?.salesMonth] = [day]
        }

        return acc
    }

    salesBreakdownByDay = dataToShowForDatesSelected?.reduce(
        dailyMonthlyOptions?.value ? reduceCallbackMonthly : reduceCallbackDaily, {}) ?? {};

    const dataToPlot = Object.keys(salesBreakdownByDay).map((key) => {
        const dateData = salesBreakdownByDay[key];
        const { order, units, amount } = dateData.reduce((accum, item) => {
            const orderDay = Number(Number(Number(accum?.order) + Number(item?.orderCount)));
            const unitsDay = Number(Number(Number(accum?.units) + Number(item?.quantity)));
            const amountDay = Number(Number(Number(accum?.amount) + Number(item?.amount)));
            return { order: orderDay, units: unitsDay, amount: amountDay }
        }, { order: 0, units: 0, amount: 0 });

        return {
            day: key,
            [keyRef.aov]: amount / order,
            [keyRef.aupt]: units / order
        }
    })

    return (
        <>
            <div className="card__title row">
                <h5 className="bold-text col-md-3">{title}</h5>
                <div className="form__form-group mb-0 col-md-7" id='dvChartFilter'>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-6">
                            <span className="form__form-group-label font-weight-bold">
                                Select Monthly/Daily</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={dailyMonthlyOptions}
                                    options={options}
                                    clearable={false}
                                    placeholder="Select Monthly/Daily"
                                    className="select_filter"
                                    onChange={setSelectedOptions}
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                    </div>
                </div>
                <div id='dvChartView'>
                {viewReportButton()}</div>
            </div>
            {dataToPlot.length ? (<Row>
                <Col sm={12} md={12}>
                    <MultiAxisBar dir={dir}
                        dataToPlot={dataToPlot}
                        height={height}
                        showTitle={false}
                        isSalesKey={isSalesKey}
                        keyRef={keyRef}
                        dailyMonthlyOptions={dailyMonthlyOptions}
                    /></Col>
            </Row>
            ) : <div className="no-data">No data to display</div>}
            <ViewSalesReportModal
                modalData={dataToPlot}
                isOpen={isOpen}
                handleModal={setIsOpen}
                title={`${vendorNameMapping[vendor]} AOV Report`}
                fileName={`${vendorNameMapping[vendor]} AOV Report`}
                tableHeaderData={aovHeaderData} />
        </>

    )
}

AOVByPurchaseDate.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShowForDatesSelected: PropTypes.array.isRequired,
    title: PropTypes.string,
    height: PropTypes.number.isRequired,
    isSalesKey: PropTypes.string,
    vendor: PropTypes.number.isRequired
};

AOVByPurchaseDate.defaultProps = {
    title: 'AOV by purchase date',
    isSalesKey: 'amount'
}

export default AOVByPurchaseDate;
